exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-info{background-color:#fff}.update-info__no-diff{font-size:15px;color:#000;text-align:center;padding:50px}", ""]);

// exports
